var _defs, _g, _defs2, _g2, _defs3, _g3, _defs4, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 26,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39.679993,
    y: -500.63,
    width: 372.03751,
    height: 805.58521,
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "matrix(0.9921 0 0 0.9921 2.67786 12.3128)",
    d: "M21.375 12.6L2.25 12.6L0 0L23.625 0L21.375 12.6L21.375 12.6Z"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39.679993,
    y: -500.63,
    width: 372.03751,
    height: 805.58521,
    clipRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "matrix(0.9921 0 0 0.9921 1.56195 10.0399)",
    d: "M25.875 2.29091L0 2.29091L0 0L25.875 0L25.875 2.29091Z"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39.679993,
    y: -500.63,
    width: 372.03751,
    height: 805.58521,
    clipRule: "evenodd"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "matrix(0.9921 0 0 0.9921 4.91003 0.9487)",
    d: "M0 6.87273L6.75 0"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip_3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39.679993,
    y: -500.63,
    width: 372.03751,
    height: 805.58521,
    clipRule: "evenodd"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip_3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "rgb(135,204,61)",
    strokeWidth: 1.5,
    strokeMiterlimit: 4,
    transform: "matrix(0.9921 0 0 0.9921 17.1873 0.9487)",
    d: "M6.75 6.87273L0 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShop);
export default __webpack_public_path__ + "static/media/icon_shop.4276205ee556f3d652217c68deaf6caa.svg";
export { ForwardRef as ReactComponent };